/**
 * ME Womo Banner
 * 自动轮播 + 进度条 + 左右切换
 */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function hasSlideMedia(slide) {
    return !!slide.querySelector(
      '.mt-womo-banner__image img, .mt-womo-banner__image video, .mt-womo-banner__image-desktop, .mt-womo-banner__image-mobile, .mt-womo-banner__video-desktop, .mt-womo-banner__video-mobile'
    );
  }

  function revealScrollEnterContent(section) {
    const inner = section.querySelector('[data-scroll-enter]');
    if (!inner) return;
    inner.querySelectorAll('.enter-title, .enter-subtitle, .enter-content').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function init() {
    const sections = document.querySelectorAll('.mt-womo-banner[data-section-id]');
    if (!sections.length) return;

    sections.forEach(setupBanner);
  }

  function setupBanner(section) {
    const track = section.querySelector('[data-track]');
    const slides = track ? Array.from(track.children) : [];
    if (!track || !slides.length) return;

    const slideCount = parseInt(section.dataset.slideCount, 10);
    const mediaSlideCount = Number.isFinite(slideCount) ? slideCount : slides.length;
    const isSingleSlide = mediaSlideCount <= 1 || slides.length <= 1;

    if (isSingleSlide) {
      section.classList.add('mt-womo-banner--single');
      const mediaSlides = slides.filter(hasSlideMedia);
      let activeIndex = 0;
      if (mediaSlides.length >= 1) {
        activeIndex = Math.max(0, slides.indexOf(mediaSlides[0]));
      }
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
      });
      track.style.transform = 'translateX(' + -activeIndex * 100 + '%)';
      revealScrollEnterContent(section);
      return;
    }

    const sectionId = section.dataset.sectionId || section.id;
    console.log('[mt-womo-banner] setupBanner for section:', sectionId);

    const prevBtn = section.querySelector('[data-prev]');
    const nextBtn = section.querySelector('[data-next]');
    const progressDots = Array.from(section.querySelectorAll('[data-progress-dot]'));
    const viewport = section.querySelector('[data-viewport]') || section;
    const leftDragZone = section.querySelector('[data-drag-left]');
    const rightDragZone = section.querySelector('[data-drag-right]');

    console.log('[mt-womo-banner] drag zones:', {
      section: sectionId,
      hasLeft: !!leftDragZone,
      hasRight: !!rightDragZone,
    });

    const autoplayInterval = parseInt(section.dataset.autoplayInterval, 10) || 5000;
    const autoplayEnabled = section.dataset.autoplayEnabled === 'true';

    let currentIndex = 0;
    let autoplayTimer = null;
    let progressStartTime = null;
    let progressRafId = null;

    function setActiveSlide(index) {
      // 激活当前 slide（保留 class 方便以后加动画）
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      // 通过平移 track 来显示对应的 slide，避免出现白屏
      const offset = -index * 100;
      track.style.transform = `translateX(${offset}%)`;
      
      // 更新 dot 点状态
      progressDots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goTo(index) {
      const total = slides.length;
      if (!total) return;
      currentIndex = (index + total) % total;
      setActiveSlide(currentIndex);
      restartProgress();
    }

    function next() {
      goTo(currentIndex + 1);
    }

    function prev() {
      goTo(currentIndex - 1);
    }

    function startAutoplay() {
      if (!autoplayEnabled) {
        // 如果未开启自动播放，则不启动计时与进度条
        stopProgress();
        return;
      }
      clearAutoplay();
      autoplayTimer = setTimeout(() => {
        next();
      }, autoplayInterval);
      startProgress();
    }

    function clearAutoplay() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startProgress() {
      const activeDot = progressDots[currentIndex];
      if (!activeDot) return;
      
      const progressBar = activeDot.querySelector('[data-progress-dot-bar]');
      if (!progressBar) return;
      
      stopProgress();
      progressStartTime = performance.now();
      progressBar.style.width = '0%';

      const loop = (now) => {
        if (!progressStartTime) return;
        const elapsed = now - progressStartTime;
        const ratio = Math.min(elapsed / autoplayInterval, 1);
        progressBar.style.width = (ratio * 100).toFixed(2) + '%';
        if (ratio < 1) {
          progressRafId = requestAnimationFrame(loop);
        } else {
          progressBar.style.width = '100%';
        }
      };

      progressRafId = requestAnimationFrame(loop);
    }

    function stopProgress() {
      if (progressRafId) {
        cancelAnimationFrame(progressRafId);
        progressRafId = null;
      }
      progressStartTime = null;
      
      // 重置所有 dot 的进度条
      progressDots.forEach((dot) => {
        const bar = dot.querySelector('[data-progress-dot-bar]');
        if (bar) {
          bar.style.width = '0%';
        }
      });
    }

    function restartProgress() {
      clearAutoplay();
      startAutoplay();
    }

    function setupDragZone(zone, position) {
      if (!zone) return;
      let isDown = false;
      let startX = 0;
      let startY = 0;

      function getClientX(event) {
        if (event.touches && event.touches.length) {
          return event.touches[0].clientX;
        }
        if (event.changedTouches && event.changedTouches.length) {
          return event.changedTouches[0].clientX;
        }
        return event.clientX;
      }

      function startDrag(clientX, clientY) {
        isDown = true;
        startX = clientX;
        startY = clientY != null ? clientY : 0;
        zone.classList.add('is-dragging');
        section.classList.add('is-dragging');
        console.log('[mt-womo-banner] drag start:', {
          section: sectionId,
          position,
          startX,
        });
      }

      function endDrag(clientX, clientY) {
        isDown = false;
        zone.classList.remove('is-dragging');
        section.classList.remove('is-dragging');
        const deltaX = clientX - startX;
        const deltaY = (clientY != null ? clientY : 0) - startY;
        const threshold = 10;
        console.log('[mt-womo-banner] drag end:', {
          section: sectionId,
          position,
          endX: clientX,
          endY: clientY,
          deltaX,
          deltaY,
          threshold,
        });

        // 仅在水平位移明显大于垂直位移时，才触发切换；否则视为上下滑动，不切换
        if (Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        if (deltaX <= -threshold) {
          // 向左拖动：下一张
          next();
        } else if (deltaX >= threshold) {
          // 向右拖动：上一张
          prev();
        }
      }

      function onMouseDown(e) {
        e.preventDefault();
        startDrag(e.clientX, e.clientY);
      }

      function onMouseMove() {
        if (!isDown) return;
        // 这里只记录移动，不做实时位移渲染
      }

      function onMouseUp(e) {
        if (!isDown) return;
        endDrag(e.clientX, e.clientY);
      }

      function onTouchStart(e) {
        const clientX = getClientX(e);
        const clientY = e.touches && e.touches.length ? e.touches[0].clientY : null;
        if (clientX == null) return;
        startDrag(clientX, clientY);
      }

      function onTouchEnd(e) {
        if (!isDown) return;
        const clientX = getClientX(e);
        const clientY =
          (e.changedTouches && e.changedTouches.length ? e.changedTouches[0].clientY : null) ||
          (e.touches && e.touches.length ? e.touches[0].clientY : null);
        if (clientX == null || clientY == null) return;
        endDrag(clientX, clientY);
      }

      zone.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
      zone.addEventListener('touchstart', onTouchStart, { passive: true });
      window.addEventListener('touchend', onTouchEnd);
    }

    // 交互绑定
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        next();
      });
    }

    // Dot 点点击切换
    progressDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goTo(index);
      });
    });

    // 初始化
    setActiveSlide(currentIndex);
    if (autoplayEnabled) {
      startAutoplay();
    } else {
      stopProgress();
    }

    // 左右 100px 区域拖拽切换
    setupDragZone(leftDragZone, 'left');
    setupDragZone(rightDragZone, 'right');
  }
})();
